import type { JSONSchema6, JSONSchema6TypeName } from "json-schema";

export interface ExtendedJSONSchema extends JSONSchema6 {
  is_hidden?: boolean;
  is_secret?: boolean;
  order?: number;
  group_order?: number;
  input_type?: string;
  /** Optional display labels for `enum` values (keyed by enum value). */
  enum_labels?: Record<string, string>;
  /** Optional header grouping fields inside a section. */
  subgroup?: string;
}

export const typeMap: Partial<{
  [Key in JSONSchema6TypeName]: {
    inputType: string;
    defaultValue: any;
  };
}> = {
  integer: {
    inputType: "number",
    defaultValue: 0,
  },
  number: {
    inputType: "number",
    defaultValue: 0,
  },
  string: {
    inputType: "text",
    defaultValue: "",
  },
  boolean: {
    inputType: "checkbox",
    defaultValue: false,
  },
};

/**
 * Type definitions for grouped and field management
 * @see SystemSettings.utils for implementations:
 *   - FieldEntry: Tuple type for [key, options] field entries
 *   - GroupedFields: Interface for grouped fields structure
 *   - groupFieldsBySection(): Groups fields by section
 *   - getSectionNames(): Gets sorted section names
 */
